export default "__VITE_ASSET__4919d580__"